// SpotStyles.js - Styled Components for SpotGoMain
// 🎯 [Refactor] Extracted from SpotGoMain.js for better maintainability

import styled, { keyframes, css } from 'styled-components';

// [Light Theme Colors] - Enhanced Transparency
export const THEME = {
  bg: 'transparent',
  cardBg: 'rgba(255, 255, 255, 0.85)',
  textPrimary: '#1F2937',
  textSecondary: '#4B5563',
  primary: '#6C5CE7',
  primaryLight: '#A29BFE',
  border: 'rgba(255, 255, 255, 0.4)',
  accent: '#FFD700',
  white: 'rgba(255, 255, 255, 0.95)',
  headerBg: 'transparent',
  headerGradient: 'linear-gradient(135deg, #a8c0ff 0%, #3f2b96 100%)',
  headerText: '#FFFFFF',
  headerTextSecondary: 'rgba(255, 255, 255, 0.7)',
};

// --- Animations ---
export const ripple = keyframes`
  0% { transform: scale(0.8); opacity: 0.3; }
  100% { transform: scale(1.5); opacity: 0; }
`;

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const sweepKey = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const twinkle = keyframes`
  0% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
  25% { transform: translate(-50%, -50%) scale(2); opacity: 1; background: #FFFFFF; box-shadow: 0 0 15px #FFFFFF, 0 0 25px #FFFFFF; }
  50% { transform: translate(-50%, -50%) scale(2.5); opacity: 0.9; background: #FFFFFF; box-shadow: 0 0 20px #FFFFFF, 0 0 35px #FFFFFF; }
  75% { transform: translate(-50%, -50%) scale(2); opacity: 1; background: #FFFFFF; box-shadow: 0 0 15px #FFFFFF, 0 0 25px #FFFFFF; }
  100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
`;

export const slideUp = keyframes`
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
`;

// --- Main Container ---
export const Container = styled.div`
  position: fixed;
  top: ${props => props.$isTestnet ? '24px' : '0'};
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: ${props => props.$isTestnet ? 'calc(100vh - 24px)' : '100vh'};
  height: ${props => props.$isTestnet ? 'calc(100dvh - 24px)' : '100dvh'};
  display: flex;
  .leaflet-control-attribution a {
    pointer-events: none !important;
    text-decoration: none !important;
    color: rgba(0,0,0,0.4) !important;
    cursor: default !important;
  }
  flex-direction: column;
  background: transparent;
  color: ${THEME.textPrimary};
  overflow: hidden;
  overscroll-behavior: none;
  z-index: 1000;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes spinIcon {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const RippleContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  pointer-events: none;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
`;

export const RippleCircle = styled.div`
  width: 40px;
  height: 40px;
  background: ${THEME.primaryLight};
  border-radius: 50%;
  opacity: 0.1;
  animation: ${ripple} 2s infinite ease-out;
`;

export const MapArea = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  z-index: 10;
  overflow: visible;
  & > div { height: 100%; }
`;

export const HeaderArea = styled.div`
  position: relative;
  flex-shrink: 0;
  z-index: 100;
  background: linear-gradient(180deg, #6B5AA0 0%, #7B6AB0 25%, #8B7AC0 50%, #9B8AD0 75%, #AB9AE0 100%);
  padding-bottom: 4px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  overflow: visible;
`;

export const StickyNav = styled.div`
  position: relative;
  flex-shrink: 0;
  z-index: 110;
  background: rgba(255, 255, 255, 1);
  border-radius: 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  overflow: visible;
`;

export const TopBar = styled.div`
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  border-bottom: none;
  z-index: 10;
`;

export const MapToggleButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s;
  &:active { transform: scale(0.95); }
`;

export const MenuButton = styled(MapToggleButton)`color: #FFFFFF;`;
export const SearchButton = styled(MapToggleButton)``;
export const NotificationButton = styled(MapToggleButton)`
  position: relative;
`;

export const RedDot = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  background: #ff4444;
  border-radius: 50%;
  border: 2px solid white;
  animation: pulse 2s ease-in-out infinite;
  
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.7;
      transform: scale(1.3);
    }
  }
`;

export const PiLoginButton = styled.button`
  background: linear-gradient(135deg, #FFD700 0%, #FFBA00 50%, #FFA500 100%);
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  color: #1a1a1a;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(255, 186, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3);
  animation: pulseWarning 2s ease-in-out infinite;
  
  @keyframes pulseWarning {
    0%, 100% { 
      opacity: 0.7; 
      box-shadow: 0 2px 8px rgba(255, 186, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3);
    }
    50% { 
      opacity: 1; 
      box-shadow: 0 4px 16px rgba(255, 186, 0, 0.7), inset 0 1px 0 rgba(255, 255, 255, 0.5);
    }
  }
  
  &:hover { 
    transform: translateY(-1px); 
    box-shadow: 0 4px 12px rgba(255, 186, 0, 0.5); 
    animation: none; /* 호버 시 애니메이션 중지 */
  }
  &:active { transform: scale(0.95); }
`;

export const ScanButton = styled.button`
  background: linear-gradient(135deg, #FFD700 0%, #FFBA00 50%, #FFA500 100%);
  border: none;
  border-radius: 24px;
  padding: 10px 24px;
  color: #1a1a1a;
  font-weight: 800;
  font-size: 0.85rem;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(255, 186, 0, 0.45), 0 2px 4px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.4);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  &:hover { transform: translateY(-1px); }
  &:active { transform: scale(0.96) translateY(0); }
  svg { font-size: 1.1rem; filter: drop-shadow(0 1px 1px rgba(0,0,0,0.15)); }
`;

export const UserBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 8px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  min-width: 70px;
  justify-content: flex-start;
  height: 28px;
`;

export const Avatar = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
`;

export const PointText = styled.span`
  font-size: 0.65rem;
  font-weight: 600;
  color: ${THEME.textPrimary};
`;

export const ProgressBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, transparent, ${THEME.primary}, transparent);
  animation: loading 1.5s infinite;
  @keyframes loading {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
  }
`;





export const TabsHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 0;
  background: transparent;
  border-bottom: 1px solid #f3f4f6;
`;

export const Tab = styled.button`
  background: none;
  border: none;
  padding: 12px 8px;
  color: ${props => props.$active ? '#1F2937' : '#9CA3AF'};
  font-weight: ${props => props.$active ? '800' : '600'};
  font-size: 0.8rem;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%; transform: translateX(-50%);
    width: ${props => props.$active ? 'calc(100% - 16px)' : '0'};
    height: 3px;
    background: #6C5CE7;
    transition: all 0.2s;
  }
`;

export const FeedList = styled.div`
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #EEF2FF; 
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 80px;
`;

export const SpotCard = styled.div`
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  padding: 4px 10px;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06); 
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
  margin-bottom: 0px;
  &:active { transform: scale(0.98); }
  
  /* 🎯 지도 마커 클릭 시 보라색 강조 펄스 */
  &.highlight-pulse {
    animation: feedPulse 0.6s ease-in-out 3;
    background: rgba(108, 92, 231, 0.08);
    border-left: 4px solid #6C5CE7;
    box-shadow: 0 0 20px rgba(108, 92, 231, 0.3);
  }
  
  @keyframes feedPulse {
    0%, 100% { 
      transform: scale(1);
      background: rgba(108, 92, 231, 0.05);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    50% { 
      transform: scale(1.01);
      background: rgba(108, 92, 231, 0.12);
      box-shadow: 0 0 20px rgba(108, 92, 231, 0.4);
    }
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
`;

export const TypeBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  font-weight: 700;
  color: ${props => props.$type === 'store' ? '#DC2626' : props.$type === 'footprint' ? '#B45309' : '#0369A1'};
  background: ${props => props.$type === 'store' ? '#FEE2E2' : props.$type === 'footprint' ? '#FEF3C7' : '#E0F2FE'};
  padding: 3px 8px;
  border-radius: 6px;
`;

export const Distance = styled.span`
  font-size: 0.7rem;
  color: ${THEME.textSecondary};
  font-weight: 500;
`;

export const CardBody = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 2px;
  align-items: center;
`;

export const CardTextColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CardImageColumn = styled.div`
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 12px;
  overflow: hidden;
  background: #f3f4f6;
  border: 1px solid rgba(0,0,0,0.05);
`;

export const SpotThumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CardTitle = styled.h3`
  font-size: 0.88rem;
  font-weight: 700;
  margin: 0;
  color: ${THEME.textPrimary};
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardContent = styled.p`
  font-size: 0.8rem;
  color: ${THEME.textSecondary};
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(0,0,0,0.03);
  padding-top: 4px;
`;

export const VerificationInfo = styled.div`
  font-size: 0.85rem;
  color: ${THEME.textSecondary};
  display: flex;
  align-items: center;
  gap: 4px;
  b { color: ${THEME.textPrimary}; }
`;

export const FloatingAddBtn = styled.button`
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, ${THEME.primary}, ${THEME.primaryLight});
  border: none;
  box-shadow: 0 4px 15px rgba(108, 92, 231, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2000;
  transition: all 0.2s;
  &:hover { transform: translateY(-3px) rotate(90deg); }
  &:active { transform: translateY(0); }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 0;
  color: ${THEME.textSecondary};
  font-size: 0.95rem;
  line-height: 1.6;
`;

// --- Modal Styled Components ---
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  z-index: 12500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  width: 100%;
  max-width: 360px;
  padding: 26px 24px 22px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.6);
  text-align: center;
  animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  @keyframes popIn {
    0% { transform: scale(0.9); opacity: 0; }
    100% { transform: scale(1); opacity: 1; }
  }
`;

export const ModalMessage = styled.p`
  font-size: 1rem;
  color: ${THEME.textPrimary};
  margin-bottom: 24px;
  line-height: 1.6;
  font-weight: 600;
  text-align: center;
  white-space: pre-line;
  word-break: keep-all;
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

export const ModalButton = styled.button`
  flex: 1;
  min-height: 42px;
  padding: 10px 0;
  border-radius: 12px;
  border: none;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  background: ${props => props.$secondary ? '#E5E7EB' : THEME.primary};
  color: ${props => props.$secondary ? '#374151' : 'white'};
  transition: all 0.2s;
  &:hover { background: ${props => props.$secondary ? '#D1D5DB' : '#5A4AD1'}; }
`;

export const RegModalContent = styled(ModalContent)`
  max-width: 360px;
  text-align: left;
`;

export const RegTypeContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 24px;
`;

export const RegTypeButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 6px;
  border-radius: 14px;
  border: 2px solid ${props => props.$selected ? THEME.primary : 'transparent'};
  background: ${props => props.$selected ? '#EEF2FF' : '#F3F4F6'};
  color: ${props => props.$selected ? THEME.primary : '#6B7280'};
  cursor: pointer;
  transition: all 0.2s;
  span { font-weight: 700; font-size: 0.85rem; line-height: 1.2; text-align: center; word-break: keep-all; }
  small { font-size: 0.72rem; opacity: 0.8; font-weight: 600; }
  svg { flex-shrink: 0; }
  
  &:active {
    transform: scale(0.96);
  }
`;

export const SlotBadge = styled.div`
  font-size: 0.65rem;
  font-weight: 800;
  padding: 2px 6px;
  border-radius: 6px;
  margin-top: 4px;
  background: ${props => 
    props.$status === 'free' ? 'rgba(16, 185, 129, 0.15)' : 
    props.$status === 'permanent' ? 'rgba(245, 158, 11, 0.15)' : 
    props.$status === 'unowned' ? 'rgba(107, 114, 128, 0.1)' : 
    props.$status === 'registered' ? 'rgba(239, 68, 68, 0.1)' : 
    'rgba(99, 102, 241, 0.1)'
  };
  color: ${props => 
    props.$status === 'free' ? '#059669' : 
    props.$status === 'permanent' ? '#D97706' : 
    props.$status === 'unowned' ? '#9CA3AF' : 
    props.$status === 'registered' ? '#DC2626' : 
    '#4F46E5'
  };
  border: 1px solid ${props => 
    props.$status === 'free' ? 'rgba(16, 185, 129, 0.3)' : 
    props.$status === 'permanent' ? 'rgba(245, 158, 11, 0.3)' : 
    props.$status === 'unowned' ? 'rgba(107, 114, 128, 0.2)' : 
    props.$status === 'registered' ? 'rgba(239, 68, 68, 0.3)' : 
    'rgba(99, 102, 241, 0.3)'
  };
`;

export const RegInput = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #E5E7EB;
  background: #F9FAFB;
  margin-bottom: 12px;
  font-size: 0.95rem;
  &:focus { outline: 2px solid ${THEME.primaryLight}; }
`;

export const RegTextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #E5E7EB;
  background: #F9FAFB;
  margin-bottom: 12px;
  min-height: 150px;
  max-height: 200px;
  font-size: 0.9rem;
  font-family: inherit;
  resize: vertical;
  &:focus { outline: 2px solid ${THEME.primaryLight}; }
`;

// --- Radar Components ---
export const RadarContainer = styled.div`
  /* 🎯 [Fix] height: auto는 transition이 안 되므로 max-height 사용 */
  max-height: ${props => props.$show ? '400px' : '0px'};
  opacity: ${props => props.$show ? '1' : '0'};
  /* 애니메이션 중 내용이 넘치지 않도록 hidden 처리 */
  overflow: hidden; 
  padding: ${props => props.$show ? '10px 0' : '0'};
  
  /* 부드러운 애니메이션 (max-height와 opacity 동시 적용) */
  transition: max-height 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94),
              opacity 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
              padding 0.4s ease;
              
  background: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: none;
  position: relative;
  z-index: 1;
  gap: 2px;
`;

export const RadarScreen = styled.div`
  width: 110px;
  height: 110px;
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;
  transform: rotate(${props => props.$rotation || 0}deg);
  touch-action: none;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  background: 
    radial-gradient(ellipse 80% 50% at 50% 15%, rgba(200, 230, 255, 0.5) 0%, rgba(180, 220, 250, 0.2) 40%, transparent 70%),
    radial-gradient(circle at 50% 55%, rgba(100, 180, 220, 0.6) 0%, rgba(80, 150, 200, 0.4) 30%, transparent 60%),
    radial-gradient(circle at center, rgba(70, 140, 190, 0.75) 0%, rgba(80, 155, 205, 0.7) 20%, rgba(90, 165, 215, 0.65) 40%, rgba(100, 175, 220, 0.55) 60%, rgba(110, 185, 225, 0.4) 80%, rgba(130, 200, 235, 0.25) 100%);
  
  &::after {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    border-radius: 50%;
    background-image: 
      linear-gradient(0deg, rgba(130, 200, 235, 0.5) 0%, rgba(160, 220, 250, 0.7) 50%, rgba(130, 200, 235, 0.5) 100%),
      linear-gradient(90deg, rgba(130, 200, 235, 0.5) 0%, rgba(160, 220, 250, 0.7) 50%, rgba(130, 200, 235, 0.5) 100%),
      radial-gradient(closest-side, transparent 15px, rgba(140, 210, 240, 0.5) 16px, transparent 17px),
      radial-gradient(closest-side, transparent 32px, rgba(140, 210, 240, 0.4) 33px, transparent 34px),
      radial-gradient(closest-side, transparent 48px, rgba(140, 210, 240, 0.3) 49px, transparent 50px);
    background-size: 2px 100%, 100% 2px, 100% 100%, 100% 100%, 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    pointer-events: none;
    z-index: 2;
  }
  
  border: 2.5px solid rgba(140, 220, 255, 0.8);
  box-shadow: 
    0 0 6px rgba(100, 200, 240, 0.9), 0 0 15px rgba(120, 210, 250, 0.7), 0 0 30px rgba(140, 220, 255, 0.5), 0 0 45px rgba(160, 230, 255, 0.25),
    inset 0 0 20px rgba(60, 130, 180, 0.5), inset 0 0 40px rgba(80, 150, 200, 0.3), inset 0 10px 20px rgba(50, 100, 150, 0.3);
`;

export const FadeGradient = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 120px;
  background: linear-gradient(to top, #F3F4F6 10%, rgba(243, 244, 246, 0) 100%);
  pointer-events: none;
  z-index: 50;
`;

export const RadarSweep = styled.div`
  position: absolute; top: 0; left: 0; right: 0; bottom: 0;
  border-radius: 50%;
  background: conic-gradient(from 0deg, transparent 0deg, transparent 270deg, rgba(100, 149, 237, 0.02) 290deg, rgba(138, 148, 245, 0.08) 320deg, rgba(100, 149, 237, 0.18) 345deg, rgba(138, 148, 245, 0.35) 355deg, rgba(100, 149, 237, 0.5) 358deg, rgba(120, 160, 255, 0.7) 360deg);
  animation: ${sweepKey} 4s infinite linear;
  z-index: 1;
`;

export const RadarBlip = styled.div`
  position: absolute;
  width: 5px; 
  height: 5px;
  border-radius: 50%;
  background: ${props => props.$type === 'store' ? '#EF4444' : props.$type === 'footprint' ? '#FBBF24' : '#3B82F6'};
  box-shadow: 0 0 4px ${props => props.$type === 'store' ? 'rgba(239, 68, 68, 0.7)' : props.$type === 'footprint' ? 'rgba(251, 191, 36, 0.7)' : 'rgba(59, 130, 246, 0.7)'};
  transform: translate(-50%, -50%);
  z-index: ${props => props.$active ? '70' : '60'};
  transition: all 0.3s ease-out;
  ${props => props.$active && css`
    animation: ${twinkle} 1s infinite ease-in-out;
    width: 6px;
    height: 6px;
    background: #FFFFFF;
    box-shadow: 0 0 8px #FFFFFF, 0 0 12px rgba(255,255,255,0.7);
  `}
`;

export const RadarFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 4px;
  margin-bottom: 8px;
  position: relative;
  z-index: 10;
`;

export const RadarStatusText = styled.div`
  position: static;
  margin: 0;
  font-size: 0.7rem;
  color: #FFFFFF;
  font-weight: 500;
  text-align: left;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.4);
`;

export const CenterAvatarContainer = styled.div`
  width: 15px; height: 15px;
  background: linear-gradient(135deg, #E8F5FF 0%, #C0E0F8 100%);
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.9);
  color: #374151;
  z-index: 50;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 0 6px rgba(100, 180, 210, 0.6), 0 0 12px rgba(120, 190, 220, 0.4);
  position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
  animation: centerPulse 3s ease-in-out infinite;
  @keyframes centerPulse {
    0%, 100% { box-shadow: 0 0 6px rgba(100, 180, 210, 0.6), 0 0 12px rgba(120, 190, 220, 0.4); }
    50% { box-shadow: 0 0 10px rgba(100, 180, 210, 0.8), 0 0 20px rgba(120, 190, 220, 0.5); }
  }
`;

export const CenterAvatarImg = styled.img`width: 100%; height: 100%; border-radius: 50%; object-fit: cover;`;

export const RadarHandle = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0;
  z-index: 20;
  color: #4B5563;
  transition: all 0.2s;
  &:hover { background: rgba(255, 255, 255, 0.3); }
`;

export const RadarSideList = styled.div`
  position: absolute;
  top: 60%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 100;
  align-items: center;
`;

export const SideTitle = styled.div`
  font-size: 0.65rem;
  font-weight: 800;
  color: #4B5563;
  margin-bottom: 4px;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
  width: 100%;
  text-align: center;
`;

export const ControlsContainer = styled.div`
  padding: 8px 8px 2px 8px;
  display: flex;
  justify-content: flex-start;
  gap: 4px;
  overflow-x: auto;
  overflow-y: visible; /* 🎯 [Fix] 50km 남은시간 배지 세로 클리핑 방지 */
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar { display: none; }
`;

export const DistanceChip = styled.button`
  background: ${props => props.$active ? '#6C5CE7' : 'white'};
  color: ${props => props.$active ? 'white' : '#6B7280'};
  border: 1px solid ${props => props.$active ? '#6C5CE7' : '#E5E7EB'};
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover { transform: translateY(-1px); }
  &:active { transform: scale(0.95); }
`;


export const SideText = styled.span`
  color: #374151;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  text-align: left;
`;

export const ImageUploadPlaceholder = styled.div`
  width: 100%;
  height: 60px;
  border: 2px dashed #D1D5DB;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #9CA3AF;
  cursor: pointer;
  margin-bottom: 12px;
  transition: all 0.2s;
  &:hover { border-color: ${THEME.primary}; color: ${THEME.primary}; }
  svg { font-size: 1.2rem; }
  span { font-size: 0.85rem; }
`;

// --- Detail Modal ---
export const DetailModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.2);
  z-index: 12000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

export const DetailModalContent = styled.div`
  width: 100%;
  max-width: 600px;
  background: white;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  box-shadow: 0 -4px 20px rgba(0,0,0,0.15);
  display: flex; flex-direction: column;
  position: absolute;
  top: 12%; 
  bottom: 0;
  height: auto; 
  animation: ${slideUp} 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
`;

export const DetailHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #f3f4f6;
  background: white;
  z-index: 10;
`;

export const DetailBody = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
  -webkit-overflow-scrolling: touch;
`;

export const DetailFooter = styled.div`
  padding: 16px 20px;
  padding-bottom: calc(90px + env(safe-area-inset-bottom));
  border-top: 1px solid #f3f4f6;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const CommentSection = styled.div`
  margin-top: 24px;
  border-top: 1px solid #eee;
  padding-top: 16px;
`;

export const CommentList = styled.div`
  display: flex; flex-direction: column; gap: 12px;
  margin-bottom: 16px;
`;

export const CommentItem = styled.div`
  background: #f9fafb;
  padding: 10px;
  border-radius: 8px;
  font-size: 0.85rem;
  strong { font-weight: 600; color: #374151; display: block; margin-bottom: 2px; }
  span { color: #4B5563; }
`;

export const CommentInputBox = styled.div`
  display: flex; gap: 8px;
  input { 
    flex: 1; padding: 8px 12px; border-radius: 20px; border: 1px solid #ddd; font-size: 0.9rem;
    &:focus { outline: 1px solid ${THEME.primary}; }
  }
  button {
    background: ${THEME.primary}; color: white; border: none; padding: 0 16px; border-radius: 20px; font-weight: 600; cursor: pointer;
  }
`;

// 🎯 [UI 통일] Gray 스타일 - 피드 목록과 일관성
export const LikeButton = styled.button`
  padding: 8px 14px;
  border-radius: 12px;
  border: 1px solid #E5E7EB;
  background: #F9FAFB;
  color: #6B7280;
  font-weight: 700;
  display: flex; align-items: center; justify-content: center; gap: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
  white-space: nowrap;
  &:hover { background: #F3F4F6; }
  &:active { transform: scale(0.98); }
`;

// 🎯 [UI 통일] Gray 스타일 - 피드 목록과 일관성
export const AuthButton = styled.button`
  padding: 8px 14px;
  border-radius: 12px;
  border: 1px solid #E5E7EB;
  background: #F9FAFB;
  color: #6B7280;
  font-weight: 700;
  display: flex; align-items: center; justify-content: center; gap: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
  white-space: nowrap;
  &:hover { background: #F3F4F6; }
  &:active { transform: scale(0.98); }
`;

// 🎯 [Refactor] 공통 레이아웃 컴포넌트 - 인라인 스타일 최소화 (옵션 A)
export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.$gap || '8px'};
  ${props => props.$justify && `justify-content: ${props.$justify};`}
  ${props => props.$wrap && 'flex-wrap: wrap;'}
  ${props => props.$fullWidth && 'width: 100%;'}
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.$gap || '8px'};
  ${props => props.$align && `align-items: ${props.$align};`}
  ${props => props.$justify && `justify-content: ${props.$justify};`}
  ${props => props.$fullWidth && 'width: 100%;'}
  ${props => props.$fullHeight && 'height: 100%;'}
`;

export const CenteredContainer = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: ${props => props.$gap || '6px'};
`;

export const RelativeContainer = styled.div`
  position: relative;
  ${props => props.$cursor && `cursor: ${props.$cursor};`}
`;
